import { BonusLeaseTypeFilter } from '../api-client';

export const bonusLeaseTypeUiItems = [
  { label: 'All', value: BonusLeaseTypeFilter.All },
  { label: 'Non-Lease', value: BonusLeaseTypeFilter.NonLease },
  { label: 'With Lease', value: BonusLeaseTypeFilter.WithLease }
];
